import { fetchDataAndProceed } from '../../config/utils'
import { METHOD_TYPES } from '../../config/constants'

export const getFunnelAnalyticsData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/analytics/salesFunnelAnalytics', METHOD_TYPES.GET, data, callback)
}


// WEBPACK FOOTER //
// ./src/data/redux/conversion_details/api.js